<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        v-model="searchForm.nodeNumber"
        placeholder="请输入节点名称"
        @keyup.enter.native="getTableList"
      ></el-input>
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/nodePowerDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
        <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      width="110"
      prop="date"
      label="时间">
    </el-table-column>
    <el-table-column
      prop="nodeNumber"
      label="节点名称">
    </el-table-column>
    <el-table-column
      prop="rewards"
      width="110"
      label="出块奖励(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.rewards,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="luckyValue"
      width="110"
      label="幸运值(%)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.luckyValue)*100,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="releasePower"
      width="120"
      label="到期算力(TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.releasePower),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="releaseFil"
      width="170"
      label="到期质押退回金额(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.releaseFil),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="powerGrowth"
      width="120"
      label="新增算力(TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.powerGrowth,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="ecologyGas"
      width="120"
      label="生态维护Gas费">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.ecologyGas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="productGas"
      width="120"
      label="生产Gas消耗">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.productGas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="otherGas"
      label="其它Gas">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.otherGas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="130px"
      prop="totalGas"
      label="总Gas合计">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalGas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="newUnitGas"
      width="140"
      label="单T Gas费(FIL/T)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.newUnitGas),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="pledge"
      width="120"
      label="总质押币(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.pledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="newPledge"
      width="160px"
      label="当日新增质押币(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.newPledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="unitPledge"
      width="160px"
      label="单TiB质押币(FIL/TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.unitPledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="burn"
      width="100px"
      label="惩罚值(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.burn,4)}}</span>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        nodeNumber: null,
        startTime:'',
        endTime:'',
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.nodePowerDaily({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
